import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Typography
} from "@mui/material";
import CustomizedTables from "../component/CustomizedTables";
import { useEffect, useState } from "react";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import axios from "axios";
import { PAYMENT_GET, PAYMENT_SAVE } from "../apis/Endpoint";
import { format } from "date-fns";

const columns = [
  { label: 'Date', key: 'date' },
  { label: 'Type', key: 'type', align: 'left' },
  { label: 'Amount', key: 'amount', align: 'right' },
  { label: 'Description', key: 'description', align: 'right' },
];

const Payment = () => {
  const [payment, setPayment] = useState({
    date: "",
    type: "",
    amount: 0,
    description: ""
  });

  const [paymentList, setPaymentList] = useState([]);
  const [open, setOpen] = useState(false);

  const handleChange = (event) => {
    const { name, value } = event.target;
    setPayment({
      ...payment,
      [name]: name === "amount" ? parseFloat(value) || 0 : value
    });
  };

  const handleAdd = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const getPayment = () => {
    axios.get(PAYMENT_GET).then((res) => {
      setPaymentList(res.data.data);
    });
  };

  useEffect(() => {
    getPayment();
  }, []);

  const handleSubmit = () => {
    const { date, type, amount } = payment;
    if (!date || !type || amount <= 0) {
      alert("Please fill in all fields with valid data.");
      return;
    }

    axios.post(PAYMENT_SAVE, payment)
      .then((res) => {
        if (res.data.message === "Payment added successfully") {
          getPayment();
          setPayment({
            date: "",
            type: "",
            amount: 0,
            description: ""
          });
          setOpen(false);
        } else {
          alert(res.data.message);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  return (
    <Box sx={{
      width: "100%",
      height: "100vh",
      display: "flex",
      flexDirection: 'column',
      pl: 2,
      boxSizing: 'border-box',
      pr: 1,
      alignItems: "center",
      justifyContent: "start"
    }}>
      <Dialog open={open} onClose={handleClose} fullWidth maxWidth="sm">
        <DialogTitle>New Payment</DialogTitle>
        <DialogContent>
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, padding: 2 }}>
            <LocalizationProvider dateAdapter={AdapterDateFns}>
              <DatePicker
                label="Date"
                value={payment.date ? new Date(payment.date) : null}
                onChange={(newValue) => {
                  if (newValue) {
                    setPayment({ ...payment, date: format(newValue, "yyyy-MM-dd") });
                  }
                }}
                renderInput={(params) => (
                  <TextField {...params} fullWidth variant="outlined" />
                )}
              />
            </LocalizationProvider>

            <FormControl fullWidth>
              <InputLabel>Type</InputLabel>
              <Select
                label="Type"
                name="type"
                value={payment.type}
                onChange={handleChange}
              >
                <MenuItem value="Credit">Credit</MenuItem>
                <MenuItem value="Debit">Debit</MenuItem>
              </Select>
            </FormControl>

            <TextField
              label="Amount"
              name="amount"
              value={payment.amount}
              onChange={handleChange}
              type="number"
              variant="outlined"
              fullWidth
            />

            <TextField
              label="Description"
              name="description"
              value={payment.description}
              onChange={handleChange}
              type="text"
              variant="outlined"
              fullWidth
            />
          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Cancel</Button>
          <Button onClick={handleSubmit}>Submit</Button>
        </DialogActions>
      </Dialog>

      <Box sx={{
        width: "100%",
        height: "10vh",
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
      }}>
        <Typography sx={{ fontSize: '18px', fontWeight: 'bold', color: '#8e24aa' }}>Payment</Typography>
        <Button
          variant="contained"
          size="small"
          onClick={handleAdd}
          sx={{
            backgroundColor: "#8e24aa",
            "&:hover": {
              backgroundColor: "darkviolet"
            },
            borderRadius: "8px"
          }}
        >
          +ADD
        </Button>
      </Box>

      <CustomizedTables rows={paymentList} columns={columns} />
    </Box>
  );
};

export default Payment;
